import { createFileRoute, redirect, Outlet } from "@tanstack/react-router";
import { authClient } from "@/lib/auth-client";
import { ConnectivityBanner } from "@/components/offline/connectivity-banner";
import { AppErrorBoundary } from "@/components/error-boundary";
import {
  getCachedSession,
  cacheSession,
  buildOfflineContext,
} from "@/lib/offline-session";

export const Route = createFileRoute("/_wizard")({
  beforeLoad: async ({ location }) => {
    let networkFailed = false;

    // 1. Try normal online session validation first
    try {
      const { data: session } = await authClient.getSession();
      if (session?.user) {
        // Cache session for offline use (fire-and-forget)
        cacheSession(session.user, session.session).catch(() => {});
        return {
          user: session.user,
          session: session.session,
          isOffline: false,
        };
      }
    } catch {
      // Network error -- mark for offline fallback
      networkFailed = true;
    }

    // 2. If network call failed, try cached session
    if (networkFailed) {
      const cached = await getCachedSession();
      if (cached) {
        const ctx = buildOfflineContext(cached);
        return {
          user: ctx.user,
          session: ctx.session,
          isOffline: true,
        };
      }
    }

    // 3. No valid session -- redirect to login
    throw redirect({
      to: "/login",
      search: { redirect: location.href },
    });
  },
  component: WizardLayout,
});

function WizardLayout() {
  return (
    <>
      <ConnectivityBanner />
      <div className="min-h-screen bg-surface-base">
        <AppErrorBoundary>
          <Outlet />
        </AppErrorBoundary>
      </div>
    </>
  );
}
